import React from 'react';
import styled from 'styled-components';

import { toHtml } from '@/component/customEditor/logic/serialization';
import { ViewPracticalAssessmentVideoSubmission } from '@/administration/pages/Course/pages/assessments/practicalAssessmentVideo/variants/View/ViewPracticalAssessmentVideoSubmission';

type ViewPracticalAssessmentVideoPageProps = {
  id: string;
  remoteId?: number;
  learningId?: number;
  description: string;
  title: string;
  spaceId: number;
  peerReviewEnabled: boolean;
  onSubmitted: () => void;
};

const RootStyled = styled.div`
  width: 100%;
  background: ${({ theme }) => theme.colors.primary.onMain};
  color: ${({ theme }) => theme.colors.neutral.onContainer};
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 72px 84px;
  border-radius: 20px;
  height: 100%;
  justify-content: center;
  align-items: center;
`;

const ContentStyled = styled.div`
  width: 100%;
  max-width: 776px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  word-wrap: break-word;
  overflow-x: auto;
  gap: 24px;
`;

const TextStyled = styled.div`
  ${(p) => p.theme.typography.body1};

  &.content.is-article {
    padding: 0;
  }
`;

const TitleStyled = styled.span`
  ${(p) => p.theme.typography.title2};
`;

export const ViewPracticalAssessmentVideoPage = ({
  description,
  title,
  spaceId,
  remoteId: pageRemoteId,
  learningId,
  onSubmitted: onCompleted,
  peerReviewEnabled,
}: ViewPracticalAssessmentVideoPageProps): JSX.Element => {
  return (
    <RootStyled>
      <ContentStyled>
        <TitleStyled>{title}</TitleStyled>
        <TextStyled className="content is-article" dangerouslySetInnerHTML={{ __html: toHtml(description) }}></TextStyled>
        <ViewPracticalAssessmentVideoSubmission
          spaceId={spaceId}
          pageRemoteId={pageRemoteId}
          learningId={learningId}
          peerReviewEnabled={peerReviewEnabled}
          onCompleted={onCompleted}
        />
      </ContentStyled>
    </RootStyled>
  );
};
